import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/phone.png';
import _imports_1 from '../assets/icon.png';
import _imports_2 from '../assets/androidIcon.png';
import _imports_3 from '../assets/iosIcon.png';
const _hoisted_1 = {
  class: "d-main-layout"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "phone",
  src: _imports_0,
  class: "phone-style"
}, null, -1);
const _hoisted_3 = {
  class: "right-layout"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon-layout"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "icon",
  src: _imports_1,
  class: "icon-style"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "title-style"
}, " 二维码和条形码生成器 ")], -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "introduce-layout"
}, " 终身免费、使用简单、功能完善！ ", -1);
const _hoisted_6 = {
  class: "download-layout"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "20px",
    "height": "20px",
    "margin-right": "3px"
  },
  src: _imports_2
}, null, -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "20px",
    "height": "20px",
    "margin-right": "3px"
  },
  src: _imports_3
}, null, -1);
export default {
  __name: 'DownloadComponents',
  setup(__props) {
    function androidDownload() {
      window.open("https://ms-gdown.baidu.com/appcenter/pkg/upload/f8a693de53da6e08e7e3469161b87c3a?md5hash=85b3e3be41148c031e0eacc22296a91b&timestamp=1703336024", '_self');
    }
    function iOSDownload() {
      window.open("https://apps.apple.com/app/id1610925693", "_blank");
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "primary",
        round: "",
        class: "download-button-style",
        onClick: androidDownload
      }, {
        default: _withCtx(() => [_hoisted_7, _createTextVNode("下载 ")]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        round: "",
        class: "download-button-style",
        onClick: iOSDownload
      }, {
        default: _withCtx(() => [_hoisted_8, _createTextVNode("下载 ")]),
        _: 1
      })])])]);
    };
  }
};